import React from "react";
import LoginPageRightHeader from "./LoginPageRightHeader";
import LoginPageRightForm from "./LoginPageRightForm";

const LoginPageRight = () => {
  return (
    <div className = "md:w-full w-full">
      <LoginPageRightHeader/>
      <LoginPageRightForm/>
    </div>
  );
};

export default LoginPageRight;
